import React from 'react';
import { Link } from 'react-router-dom';
import { BuildingIcon, HeartHandshakeIcon, StethoscopeIcon, LandmarkIcon, GraduationCapIcon, SparklesIcon } from 'lucide-react';
export function PartnershipsSection() {
  const partnerTypes = [{
    icon: BuildingIcon,
    title: 'Empresas',
    description: 'Responsabilidad social corporativa'
  }, {
    icon: HeartHandshakeIcon,
    title: 'Fundaciones',
    description: 'Colaboración filantrópica'
  }, {
    icon: StethoscopeIcon,
    title: 'Profesionales de salud',
    description: 'Red de especialistas'
  }, {
    icon: LandmarkIcon,
    title: 'Entidades gubernamentales',
    description: 'Programas de impacto social'
  }, {
    icon: GraduationCapIcon,
    title: 'Instituciones educativas',
    description: 'Investigación y formación'
  }, {
    icon: SparklesIcon,
    title: 'Marcas comprometidas',
    description: 'Alianzas estratégicas'
  }];
  return <section id="alianzas" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-162" data-mp="5ensapqxclex">
      <div className="max-w-6xl mx-auto" data-id="element-163" data-mp="9fpt3b0hp5j0">
        <h2 className="text-3xl sm:text-4xl font-bold text-dark text-center mb-12" data-id="element-164" data-mp="9eoit8rasn2c">
          Alianzas
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-165" data-mp="3rr354b5h3doa">
          {partnerTypes.map((partner, index) => <div key={index} className="bg-white rounded-xl p-6 text-center shadow-md hover:shadow-xl hover:scale-[1.03] transition-all duration-300" data-id="element-166" data-mp="3huzusi0gw8q9" data-mpi={index}>
              <div className="inline-flex items-center justify-center w-14 h-14 bg-primary/10 rounded-full mb-4" data-id="element-167" data-mp="38ubdnefs1s95">
                <partner.icon className="w-7 h-7 text-primary" data-id="element-168" data-mp="3dt4v1hy6q3el" />
              </div>
              <h3 className="text-lg font-bold text-dark mb-2" data-id="element-169" data-mp="172yk1lj9f6se">
                {partner.title}
              </h3>
              <p className="text-sm text-gray-600" data-id="element-170" data-mp="1c2kytzeqkv3b">{partner.description}</p>
            </div>)}
        </div>
        <div className="text-center" data-id="element-171" data-mp="19nmr99syebqd">
          <Link to="/quiero-ser-aliado" className="inline-block bg-primary text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-primary/90 transition-colors shadow-lg hover:shadow-xl" data-id="element-172" data-mp="19opgzeeji84p">
            Quiero ser Aliado
          </Link>
        </div>
      </div>
    </section>;
}